import { Component, inject, OnInit } from '@angular/core';
import { PageComponent } from '@tytapp/common';
import { HostApi } from '@tytapp/host-api';

@Component({
    selector: 'tyt-registration-benefits',
    templateUrl: './registration-benefits.component.html',
    styleUrls: ['./registration-benefits.component.scss']
})
export class RegistrationBenefitsComponent extends PageComponent implements OnInit {
    private hostApi = inject(HostApi);

    get billingEnabled() {
        return this.hostApi.capabilities.includes('web_billing:membership')
        || this.hostApi.capabilities.includes('platform_billing:membership');
    }

    async init() {
    }

    get joinUrl() {
        // CHANGE GLOBALLY (at appConfig) NOT HERE
        return `/join/membership`;
    }

}
